import { call, put, takeEvery, select } from "redux-saga/effects";
// import { AxiosDefaults } from "axios";
import { gallerys as actions } from "actions";
import { statuses, instance, gallerys } from "api";
import { SagaStates } from "Types";

function* searchGallerys(action: any) {
   const { keyword = "" } = action.payload;

   const parameters = {
      keyword,
   };

   const status: string = yield select(function (state: SagaStates) {
      return state.gallerys.search.status;
   });
   if (status === statuses.pending) return;
   try {
      yield put({
         type: actions.search.send,
      });

      // const { data } = yield call([axios, "post"], testUri, { pageNum: 1, pageSize: 15 });
      // const response: Types.Api.Response = yield call(instance.get, testUri);
      const response: SagaStates = yield call(instance.post, gallerys.search.uri, parameters);
      if ((response as any).result === "ok") {
         yield put({
            type: actions.search.success,
            payload: response,
         });
      } else {
         yield put({
            type: actions.search.fail,
            payload: response,
         });
      }
   } catch (error) {
      yield put({
         type: actions.search.fail,
         payload: error,
      });
   }
}

export function* gallerysSaga() {
   yield takeEvery(actions.search.call, searchGallerys);
}
